
import { defineComponent, PropType } from 'vue'
import { Repository } from '~/types/types'

export default defineComponent({
  name: 'MonorepoOverview',

  props: {
    loading: {
      type: Boolean,
      default: false
    },
    showAddSubRepositoryCta: {
      type: Boolean,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    totalPageCount: {
      type: Number,
      required: true
    },
    ownerLogin: {
      type: String,
      required: true
    },
    searchQuery: {
      type: String,
      required: true
    },
    subRepositoryList: {
      type: Array as PropType<Repository[]>,
      required: true
    }
  }
})
